import * as React from 'react';
import { cn } from '@/lib/utils';

const DashboardShortcutCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-dashboard-shortcut-card',
      'flex w-[220px] max-w-full flex-grow flex-wrap-reverse items-center justify-between',
      'cursor-pointer gap-6 rounded-[12px] border-2 border-solid border-[#ECE9F8] bg-white p-6',
      'transition-shadow duration-150',
      'hover:shadow-card-hover',
      'focus:shadow-card-hover',
      className
    )}
    tabIndex={0}
    {...props}
  />
));
DashboardShortcutCard.displayName = 'DashboardShortcutCard';

const DashboardShortcutCardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-dashboard-shortcut-card-content', 'flex w-[220px] max-w-full flex-grow flex-col gap-1', className)}
    {...props}
  />
));
DashboardShortcutCardContent.displayName = 'DashboardShortcutCardContent';

const DashboardShortcutCardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-dashboard-shortcut-card-header', 'flex flex-col', className)}
    {...props}
  />
));
DashboardShortcutCardHeader.displayName = 'DashboardShortcutCardHeader';

const DashboardShortcutCardHat = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('w-full truncate text-sm font-light text-[#5D6A86]', 'mb-0', className)}
    {...props}
  />
));
DashboardShortcutCardHat.displayName = 'DashboardShortcutCardHat';

const DashboardShortcutCardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('w-full truncate text-base font-bold lowercase text-[#110B3E] first-letter:uppercase', 'mb-0', className)}
    {...props}
  />
));
DashboardShortcutCardTitle.displayName = 'DashboardShortcutCardTitle';

const DashboardShortcutCardText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('text-sm font-light text-[#5D6A86]', 'mb-0', className)}
    {...props}
  />
));
DashboardShortcutCardText.displayName = 'DashboardShortcutCardText';

const DashboardShortcutCardImgWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <figure
    ref={ref}
    className={cn('relative flex-shrink-0', className)}
    {...props}
  />
));
DashboardShortcutCardImgWrapper.displayName = 'DashboardShortcutCardImgWrapper';

const DashboardShortcutCardLiveDot = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('absolute right-[-8px] top-[-8px] h-[15px] w-[15px]', 'animate-pulse rounded-full bg-success', className)}
    {...props}
  />
));
DashboardShortcutCardLiveDot.displayName = 'DashboardShortcutCardLiveDot';

const DashboardShortcutCardImg = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn('h-[54px] w-[54px] object-contain', className)}
    {...props}
  />
));
DashboardShortcutCardImg.displayName = 'DashboardShortcutCardImg';

const DashboardShortcutCardWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-dashboard-shortcut-card-wrapper', 'mb-10 flex flex-wrap gap-4', className)}
    {...props}
  />
));
DashboardShortcutCardWrapper.displayName = 'DashboardShortcutCardWrapper';

export {
  DashboardShortcutCard,
  DashboardShortcutCardContent,
  DashboardShortcutCardHeader,
  DashboardShortcutCardHat,
  DashboardShortcutCardTitle,
  DashboardShortcutCardText,
  DashboardShortcutCardImgWrapper,
  DashboardShortcutCardLiveDot,
  DashboardShortcutCardImg,
  DashboardShortcutCardWrapper
};
